import { Pipe, PipeTransform } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { DateFormat } from '../constants/date-format.constants';
import { DateConstants } from '../constants/dates.constants';
import { LsqDatePipe } from './lsq-date.pipe';

@Pipe({
    name: 'lastUpdatedDate'
})
export class LastUpdatedDatePipe implements PipeTransform {
    constructor(private _datePipe: LsqDatePipe, private _i18n: I18n) {}

    public transform(value: string): string {
        let dateString = '';

        if (value) {
            const dateValue = new Date(value);
            const isEvening = dateValue.getHours() >= DateConstants.MiddayHour;
            const parsedDate = this._datePipe.transform(dateValue, 'shortDate');
            const parsedTime = this._datePipe.transform(dateValue, DateFormat.LastUpdatedTime);
            dateString = this._i18n('Last Updated {{parsedDate}} at {{parsedTime}} {{ending}}', {
                parsedDate,
                parsedTime,
                ending: isEvening ? DateConstants.PM : DateConstants.AM
            });
        }

        return dateString;
    }
}
